import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import useDocumentTitle from '../hooks/useDocumentTitle';
import customBedwarsProject from '../data/customBedwarsProject';
import mylesEventProject from '../data/mylesEventProject';
import pluginCommissionProject from '../data/pluginCommissionProject';
import '../styles/animations.css';

const PortfolioPage = ({ projects }) => {
  const { darkMode } = useTheme();
  useDocumentTitle('Portfolio');
  const [shaking, setShaking] = useState(false);
  
  // Combine all projects and ensure proper ordering
  const allProjects = {
    hoplite: projects.hoplite,
    speedsilver: projects.speedsilver,
    customBedwars: customBedwarsProject,
    pluginCommission: pluginCommissionProject,
    mylesEvent: mylesEventProject,
    // Add other projects here in desired order
  };
  
  // Function to handle Myles Event card click
  const handleMylesEventClick = (e) => {
    e.preventDefault();
    setShaking(true);
    setTimeout(() => setShaking(false), 500); // Stop shaking after 500ms
  };
  
  return (
    <div className="pt-8 px-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto">
        {Object.entries(allProjects).map(([key, project]) => (
          key === 'mylesEvent' ? (
            <div 
              key={key}
              onClick={handleMylesEventClick}
              className={`bg-[#E0E0E0] dark:bg-[#1e293b] rounded-xl shadow-xl overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-2xl group ${shaking ? 'animate-shake' : 'hover:scale-105'}`}
            >
              <img 
                src={`${process.env.PUBLIC_URL}${project.banner}`}
                alt="" 
                className="w-full h-56 object-cover transition-all duration-300 filter blur-[1.25px] saturate-50 group-hover:blur-0 group-hover:saturate-100"
              />
              <div className="p-8">
                <h3 className="text-2xl font-bold mb-1 text-center text-[#2978C8] dark:text-[#4f9cf9]">{project.title}</h3>
                {project.role && (
                  <p className="text-lg mb-1 text-center text-[#294C6F]/80 dark:text-[#a8c7f0]/90 italic">{project.role}</p>
                )}
                {project.startDate && (
                  <p className="text-md mb-3 text-center text-[#666666] dark:text-[#a0aec0]">
                    {project.startDate} - {project.endDate || "Present"}
                  </p>
                )}
                <p className="text-red-600 dark:text-red-400 text-center font-medium">Details will become available after the in development event takes place</p>
              </div>
            </div>
          ) : (
            <Link 
              key={key}
              to={`/portfolio/${key}`}
              className="bg-[#E0E0E0] dark:bg-[#1e293b] rounded-xl shadow-xl overflow-hidden cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl group"
            >
              <img 
                src={`${process.env.PUBLIC_URL}${project.banner}`}
                alt="" 
                className="w-full h-56 object-cover transition-all duration-300 filter blur-[1.25px] saturate-50 group-hover:blur-0 group-hover:saturate-100"
              />
              <div className="p-8">
                <h3 className="text-2xl font-bold mb-1 text-center text-[#2978C8] dark:text-[#4f9cf9]">{project.title}</h3>
                {project.role && (
                  <p className="text-lg mb-1 text-center text-[#294C6F]/80 dark:text-[#a8c7f0]/90 italic">{project.role}</p>
                )}
                {project.startDate && (
                  <p className="text-md mb-3 text-center text-[#666666] dark:text-[#a0aec0]">
                    {project.startDate} - {project.endDate || "Present"}
                  </p>
                )}
                <p className="text-[#294C6F] dark:text-[#4f9cf9] text-center">Click to view details</p>
              </div>
            </Link>
          )
        ))}
      </div>
    </div>
  );
};

export default PortfolioPage; 